export default __webpack_public_path__ + "77b308c07f53a1ea7047db7083702b30.png";